import React from 'react';

const Home = ({ setActiveTab }) => {
  return (
    <div className="home">
      <h2>欢迎使用管家婆工具</h2>
      <div className="home-cards">
        <div className="card" onClick={() => setActiveTab('bill')} style={{ cursor: 'pointer' }}>
          <h3>账单管理</h3>
          <p>记录和管理日常账单</p>
        </div>
        <div className="card" onClick={() => setActiveTab('sales')} style={{ cursor: 'pointer' }}>
          <h3>出货账单</h3>
          <p>管理产品出货记录</p>
        </div>
        <div className="card" onClick={() => setActiveTab('purchase')} style={{ cursor: 'pointer' }}>
          <h3>进货账单</h3>
          <p>管理产品进货记录</p>
        </div>
        <div className="card" onClick={() => setActiveTab('statistics')} style={{ cursor: 'pointer' }}>
          <h3>统计分析</h3>
          <p>查看业务数据统计</p>
        </div>
      </div>
    </div>
  );
};

export default Home;